<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                               :config="config"
                               ref="processExecution"
                               @gotItems="setLocalVariables"
                               :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete" :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
    // Author Shi Wen Long
    // Date 2022-04-26 16:31:56

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

    export default {
        name: "sithMesStool26StockTransferWorkflowTaskView",
        mixins: [emWorkflowTaskMixin, workflowTaskMixins],
        components: {WorkflowProcessLine, WorkflowTaskComplete},
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            },
            $_emWorkflowTaskMixin_callbackApi() {
                return this.$store.state.sithMesStool26StockTransfer.baseModuleUrl + "/sithMesStool26StockTransfer/complete-feedback";
            },
            config() {
              return {
                'om_task': {
                  name: 'OM填写转库信息',
                  variables: [
                    {
                      label: '备注',
                      name: 'remark',
                      type: this.VALUE_TYPE.TEXTAREA,
                      saveTo: this.SAVE_TO.DATABASE,
                      initData: true,
                    }
                  ],
                  approveToNextTask: 'logistics_task',
                  postByApprove: (approve) => {
                      return {
                          url: this.$store.state.sithMesStoolGrn.baseModuleUrl + `/sithMesStool26StockTransfer/doAfterOmApprove?applicationId=${this.$_emWorkflowTaskMixin_businessKey}`,
                          data: {}
                      };
                  },
                },
                'logistics_task': {
                  name: '物流填写是否转库信息',
                  approveToNextTask:  'finance_task',
                  withAttachment: true,
                  withComment: true,
                  postByApprove: (approve) => {
                      return {
                          url: this.$store.state.sithMesStoolGrn.baseModuleUrl + `/sithMesStool26StockTransfer/doAfterLogisticsApprove?applicationId=${this.$_emWorkflowTaskMixin_businessKey}`,
                          data: {
                          }
                      };
                  },
                },
                'finance_task': {
                  name: '财务填写金额转账信息归档',
                  variables: [
                    {
                      label: '备注',
                      name: 'remark',
                      type: this.VALUE_TYPE.TEXTAREA,
                      saveTo: this.SAVE_TO.DATABASE,
                      initData: true,
                    }
                  ],
                  approveToNextTask: 'end'
                },
                'end': {
                  name: '结束'
                }
              }
            }
        }
    };
</script>